module.exports = __webpack_public_path__ + "static/media/Truss-Beverages-Privacy-Policy---EN_May-2020.6f7d114a.pdf";